import { FC, useState } from 'react'
import {
  IconArrowRotateRightLeft,
  Button,
  Tooltip
} from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'

import { RecalculateCreditNoteDialog } from 'CreditNotes/components/dialog/RecalculateCreditNoteDialog'
import { RecalculationFlipResultDialog } from 'CreditNotes/components/dialog/RecalculationFlipResultDialog'

type Props = {
  creditNoteId: string
}

export const ButtonRecalculateCreditNote: FC<Props> = ({ creditNoteId }) => {
  const navigate = useNavigate()
  const label = 'Recalculate credit note'

  const [showRecalculateDialog, setShowRecalculateDialog] = useState(false)
  const [createdInvoiceId, setCreatedInvoiceId] = useState<string | null>(null)

  return (
    <>
      <Tooltip label={label}>
        <Button
          variant="secondary"
          icon={<IconArrowRotateRightLeft color="inherit" />}
          aria-label={label}
          onClick={() => setShowRecalculateDialog(true)}
          data-testid="header.button.recalculate-credit-note"
        />
      </Tooltip>
      {showRecalculateDialog && (
        <RecalculateCreditNoteDialog
          creditNoteId={creditNoteId}
          isOpen
          onClose={() => setShowRecalculateDialog(false)}
          onInvoiceCreated={invoiceId => {
            setShowRecalculateDialog(false)
            setCreatedInvoiceId(invoiceId)
          }}
        />
      )}
      {createdInvoiceId && (
        <RecalculationFlipResultDialog
          isOpen
          onClose={() => setCreatedInvoiceId(null)}
          resultType="invoice"
          onConfirm={() => {
            navigate(`/invoices/${createdInvoiceId}`, {
              replace: true
            })
          }}
        />
      )}
    </>
  )
}
